import { Box, Button, Card, CardContent, Dialog, Stack, Typography, TextField, Select, FormControl, InputLabel, MenuItem } from "@mui/material";
import { useSnackbar } from "notistack";
import * as Yup from "yup"
import { useFormik, Form, FormikProvider, getIn } from "formik"
import { CustomDatePicker } from "../form/datePicker";
import React, { useEffect, useRef, useState } from "react";
import transactionServices from "../../services/transactionServices";
import { convertToIndianFormat } from "../../utils/functions";
import { DividerComponent } from "../miniComponents";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { LoadingButton } from "@mui/lab";
import bankServices from "../../services/bankServices";
import CreateBankAccountModal from "./createBankAccount";
import logsService from "../../services/logServices";
import { useSelector } from "react-redux";
import { InvestorActivityEventType } from "../../utils/eventTypes";

import { AccInformation } from "../../pages/marketPlace/property/InvestPages/accInformation";


export default function ConfirmaTransaction({
    open,
    handleClose = () => { },
    data,
    amount,
    amtTobePaid,
    amtPaid,
    commitmentDate,
    entityId,
    entityType,
    tokenName,
    listingId,
    onSubmit,
    onSuccess,
    hideNavigate = false,
    showAccInformation = false,
    footerText,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [bankAccount, setBankAccount] = useState()
    const [allBankAccount, setAllBankAccount] = useState()
    const [createBankAccount, setCreateBankAccount] = useState(false)
    const navigate = useNavigate();
    const user = useSelector(state => state.user.data)

    const getBankAccountOfEntity = async () => {
        try {
            const res = await bankServices.getBankAccountByStatus(entityId, "APPROVED,PENDING,REJECTED")
            if (res && res.success) {
                setBankAccount(res?.data?.filter(account => account.status === "APPROVED"));
                setAllBankAccount(res?.data)
            }
            else enqueueSnackbar(res?.data?.message || "Something went wrong", { variant: "error" });
        }
        catch (error) {
            enqueueSnackbar("Something went wrong", { variant: "error" });
        }
    }
    const handleCreateBankAccount = () => {
        setCreateBankAccount(true)
    };

    const transactionInfoSchema = Yup.object().shape({
        dateoftrans: Yup.date().required("Date is required"),
        chequeno: Yup.string()
            .required("Cheque No or Transaction Number is Required")
            .matches(/^[A-Za-z0-9]+$/, "Only letters and numbers are allowed"),
        amountTransferred: Yup.number()
            .min(1, "Enter a valid transfer amount above 0")
            .max(Number(amount - amtPaid), "Enter a valid transfer amount till " + Number(amount - amtPaid))
            .required("Enter a Valid Transferred Amount in INR"),
        bankAccountId: Yup.string().required("Bank Account is required"),
    });
    const formik = useFormik({
        initialValues: {
            chequeno: '',
            dateoftrans: moment(),
            amountTransferred: Number(amtTobePaid) || 0,
            bankAccountId: '',
        },
        // enableReinitialize: true,
        validationSchema: transactionInfoSchema,
        onSubmit: async (v, { setSubmitting }) => {
            setSubmitting(true);
            try {
                const payload = {
                    amount,
                    banktransferInfo: {
                        chequeno: v.chequeno,
                        dateoftrans: v.dateoftrans.unix(),
                        amountTransferred: v.amountTransferred,
                        bankAccountId: v.bankAccountId,
                    },
                    ...(data || {}),
                };

                const req = onSubmit
                    ? await onSubmit(payload)
                    : await transactionServices.confirmPayment(payload);

                if (req && req.success !== false) {
                    enqueueSnackbar("Success", { variant: "success" });
                    resetForm();
                    if (onSuccess) {
                        await onSuccess();
                    }
                    handleClose();
                    if (!hideNavigate) {
                        navigate("/transactions");
                    }
                    if (listingId) {
                        logsService.addLog({
                            userId: user?._id,
                            event: InvestorActivityEventType.PAYMENT_REQUEST_MADE,
                            listingId,
                        });
                    }
                } else {
                    enqueueSnackbar(req?.message || req?.data?.message || "Something went wrong!!", { variant: "error" });
                }
            } catch (error) {
                enqueueSnackbar("Something went wrong", { variant: "error" });
            } finally {
                setSubmitting(false);
            }
        }
    })

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, setFieldValue, resetForm, setSubmitting } = formik
    const prevOpenRef = useRef(false);

    useEffect(() => {
        if (!open) {
            prevOpenRef.current = false;
            return;
        }
        if (!entityId) return;
        getBankAccountOfEntity();
        if (!prevOpenRef.current) {
            const payAmount = Number(amtTobePaid) || 0;
            if (payAmount > 0) {
                setFieldValue("amountTransferred", payAmount);
            }
            prevOpenRef.current = true;
        }
    }, [open, entityId, amtTobePaid, setFieldValue]);

    useEffect(() => {
        if (bankAccount && bankAccount.length > 0) {
            const primaryAccount = bankAccount.find(acc => acc.isPrimary);
            if (primaryAccount) {
                setFieldValue("bankAccountId", primaryAccount._id);
            }
        }
    }, [bankAccount, setFieldValue]);

    return (
        <>
            <CreateBankAccountModal open={createBankAccount} setOpen={setCreateBankAccount} entityType={entityType} getBankAccountOfEntity={getBankAccountOfEntity} entityId={entityId} />
            <Dialog
                scroll={"body"}
                PaperProps={{ sx: { overflow: "auto", maxWidth: 470 } }}
                open={open}
                onClose={handleClose}
            >

                <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate >
                        <Card>
                            <CardContent sx={{ paddingTop: { md: "20px" } }}>
                                <Stack direction={"row"} justifyContent={"space-between"}>
                                    <Typography variant="body3" sx={{ fontWeight: 500 }}>Confirm Transactions</Typography>
                                    <CloseIcon onClick={handleClose} sx={{ width: 24, height: 24, color: "text.disabled", cursor: "pointer" }} />
                                </Stack>
                                <Stack mt={2} spacing={3}>
                                    <Box>
                                        <DividerComponent />
                                    </Box>
                                    <Stack spacing={"10px"}>
                                        <Typography variant="body1" sx={{ fontWeight: 500 }}>Did you transfer  {convertToIndianFormat(Number(amtTobePaid))} to the required bank account?</Typography>
                                        {showAccInformation && <AccInformation />}
                                        <CustomDatePicker label={"Date of Transaction *"}
                                            minDate={moment(commitmentDate)}
                                            disableFuture={true}
                                            value={values.dateoftrans}
                                            onChange={(newValue) => {
                                                setFieldValue("dateoftrans", newValue)
                                            }
                                            }

                                        />
                                        <TextField size="small" type="text"
                                            label="Cheque No/Transaction Number *"
                                            {...getFieldProps("chequeno")}
                                            error={Boolean(touched.chequeno && errors.chequeno)}
                                            helperText={touched.chequeno && errors.chequeno}
                                        />
                                        <TextField size="small" type="number"
                                            label="Amount Transferred *"
                                            {...getFieldProps("amountTransferred")}
                                            onWheel={(event) => event.target.blur()}
                                            error={Boolean(touched.amountTransferred && errors.amountTransferred)}
                                            helperText={touched.amountTransferred && errors.amountTransferred}
                                        />
                                        {bankAccount && (
                                            <FormControl fullWidth>
                                                <InputLabel id="selectBankAccount">Select Bank Account *</InputLabel>
                                                <Select
                                                    labelId="selectBankAccount"
                                                    size="small"
                                                    label="Select Bank Account *"
                                                    value={values.bankAccountId || ''}
                                                    onChange={(e) => {
                                                        const selectedValue = e.target.value;
                                                        if (selectedValue === "create-new") {
                                                            handleCreateBankAccount(); // Open create bank flow
                                                        } else {
                                                            setFieldValue("bankAccountId", selectedValue);
                                                        }
                                                    }}
                                                    error={Boolean(touched.bankAccountId && errors.bankAccountId)}
                                                >
                                                    <MenuItem value="" disabled>Select Bank Account</MenuItem>

                                                    {bankAccount.map((acc) => (
                                                        <MenuItem key={acc._id} value={acc._id}>
                                                            {acc.bankName ? `${acc.bankName} - ${acc.accountNumber}` : acc.accountNumber}
                                                        </MenuItem>
                                                    ))}

                                                    {allBankAccount.length !== 3 && (
                                                        <MenuItem value="create-new" sx={{ fontStyle: 'italic', color: 'primary.main' }}>
                                                            + Create New Bank Account
                                                        </MenuItem>
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}



                                        <Typography variant="body2">
                                            {footerText ||
                                                `RealX will verify the payment and the ${tokenName ? tokenName.toUpperCase() : "FRAX"} will be credited to your account.`}
                                        </Typography>
                                    </Stack>
                                    <Box>
                                        <DividerComponent />
                                    </Box>
                                    <Box>
                                        <Box >
                                            {/* <Button onClick={handleSubmit} fullWidth variant="contained" >Confirm Transaction</Button> */}
                                            <Button type="submit" disabled={isSubmitting} fullWidth variant="contained" >Confirm Transaction</Button>
                                        </Box>
                                    </Box>
                                </Stack>
                            </CardContent>
                        </Card>
                    </Form>
                </FormikProvider>
            </Dialog>
        </>
    )
}
